import { render } from "./IconElectraSafetyFeatures.vue?vue&type=template&id=56c76834"
import script from "./IconElectraSafetyFeatures.vue?vue&type=script&lang=js"
export * from "./IconElectraSafetyFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__